<div
  class="container fb-container"
  [ngClass]="[isSidebarOpen ? '' : 'minimal']">
  <div class="d-flex justify-content-start">
    <button
      (click)="backToSettings()"
      class="text-decoration-none text-body-secondary btn btn-link p-0">
      < Back to ProForms
    </button>
  </div>
  <div class="card fb-card p-0 mt-3">
    <div class="fb-card-header">
      <h1 class="fs-3 mb-0 fw-light color-secondary">ProForms</h1>
      <h2 class="fs-1 fw-600 mb-0">Form Builder</h2>
    </div>
    <div class="p-3 p-lg-5 position-relative">
      <ng-container *ngIf="form; else loadingTemplate">
        <div class="sidebar" [class.open]="isSidebarOpen">
          <div class="sidebar-inner-wrapper">
            <button class="btn btn-toggle-sidebar" (click)="toggleSidebar()">
              <i *ngIf="isSidebarOpen" class="bi bi-chevron-right"></i>
              <i *ngIf="!isSidebarOpen" class="bi bi-gear"></i>
            </button>
            <div class="sidebar-body px-5 py-3 py-lg-5">
              <h3 class="fw-bold mb-1 fs-4">Settings</h3>
              <hr class="border border-tertiary border-1 mt-0" />
              <div class="form-group mb-3" *ngIf="proformAnonymousEnabled">
                <div class="d-flex align-items-start justify-content-between">
                  <label class="fw-600" for="anonymity"
                    >Make Submissions Anonymous</label
                  >
                  <button
                    aria-label="anonymity-button"
                    class="form-switch btn-reset">
                    <input
                      class="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="anonymity"
                      [checked]="form.anonymity === 'required'"
                      (change)="toggleAnonymity($event)" />
                  </button>
                </div>
              </div>
              <div class="form-group mb-3">
                <label class="form-label fw-bold" for="status">Status</label>
                <ng-select
                  labelForId="status"
                  [items]="statuses"
                  bindLabel="value"
                  [clearable]="false"
                  [searchable]="false"
                  bindValue="key"
                  [(ngModel)]="form.status"
                  name="status"
                  (ngModelChange)="updateStatus()"></ng-select>
              </div>
              <div class="form-group mb-4" *ngIf="proformQuizzesEnabled">
                <label class="form-label fw-bold" for="type">Type</label>
                <ng-select
                  labelForId="type"
                  [items]="types"
                  bindLabel="value"
                  [clearable]="false"
                  [searchable]="false"
                  bindValue="key"
                  [(ngModel)]="form.type"
                  name="type"
                  placeholder="Select Type"
                  (ngModelChange)="updateType()"></ng-select>
              </div>
              <div
                *ngIf="form.type === proFormType.QUIZ"
                class="form-group mb-3">
                <p class="fw-bold pt-2 mb-1">Quiz</p>
                <div class="mb-4">
                  <div
                    class="d-flex align-items-center justify-content-between">
                    <label class="form-label fw-400 my-0" for="passing-grade"
                      >Passing Grade (0-100)</label
                    >
                    <input
                      [formControl]="passingGradeControl"
                      type="number"
                      class="form-control text-center"
                      id="passing-grade"
                      style="max-width: 80px"
                      aria-label="Passing Grade (0-100)"
                      [ngClass]="{
                        'is-invalid': passingGradeControl.errors
                      }" />
                  </div>
                  <div
                    *ngIf="passingGradeControl.errors"
                    class="text-danger small">
                    <div *ngIf="passingGradeControl.errors?.['required']">
                      Required for quizzes.
                    </div>
                    <div
                      *ngIf="passingGradeControl.errors?.['min'] || passingGradeControl.errors?.['max']">
                      Must be between 0-100.
                    </div>
                    <div *ngIf="passingGradeControl.errors?.['notWholeNumber']">
                      Must be a whole number.
                    </div>
                  </div>
                </div>
                <p class="fw-bold mb-1">After submission,</p>
                <div
                  class="d-flex align-items-center justify-content-between mb-3">
                  <label
                    class="form-label fw-normal my-0"
                    for="show-missed-questions"
                    >Show missed questions</label
                  >
                  <button
                    aria-label="Show missed questions"
                    class="form-switch btn-reset">
                    <input
                      class="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="show-missed-questions"
                      [checked]="form.show_missed === 1"
                      (change)="updateShowMissed($event)" />
                  </button>
                </div>
                <div
                  class="d-flex align-items-start justify-content-between mb-5">
                  <label
                    class="form-label fw-normal my-0"
                    [ngClass]="{
                      'text-muted': form.show_missed !== 1
                    }"
                    for="show-correct-answers"
                    >Show correct answers to missed questions</label
                  >
                  <button
                    [disabled]="form.show_missed !== 1"
                    aria-label="Show correct answers to missed questions"
                    class="form-switch btn-reset">
                    <input
                      [disabled]="form.show_missed !== 1"
                      [ngClass]="{
                        'cursor-pointer': form.show_missed === 1
                      }"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="show-correct-answers"
                      [checked]="form.show_answers === 1"
                      (change)="updateShowAnswers($event)" />
                  </button>
                </div>
              </div>

              <div class="form-group mt-2">
                <p class="fw-bold mb-1">Sharing</p>
                <div
                  class="d-flex align-items-center justify-content-between mb-3">
                  <label
                    class="form-label fw-normal my-0"
                    for="share-form-across-districts"
                    >Share form across districts?</label
                  >
                  <button
                    aria-label="Share form across districts"
                    class="form-switch btn-reset">
                    <input
                      class="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="share-form-across-districts"
                      [checked]="form.is_shared === 1"
                      (change)="toggleSharing($event)" />
                  </button>
                </div>
              </div>
              <ng-container *ngIf="form.is_shared === 1">
                <div class="mb-3">
                  <label class="mb-2">
                    Share with these districts (default is share across all your
                    districts):
                  </label>
                  <app-district-select
                    #shareWithDistrictSelect
                    (selectedDistrictList)="handleShareDistricts($event)"
                    [defaultDistricts]="districtsSharedWith"
                    [isMulti]="true"></app-district-select>
                </div>
                <div class="mb-3">
                  <label class="mb-2">Exclude these districts:</label>
                  <app-district-select
                    #excludeFromDistrictSelect
                    (selectedDistrictList)="handleExcludeDistricts($event)"
                    [defaultDistricts]="districtsExcludedFrom"
                    [isMulti]="true"></app-district-select>
                </div>
              </ng-container>
              <ng-container *ngIf="isArchived">
                <button
                  class="btn btn-delete px-0 mt-5"
                  [autoClose]="'outside'"
                  [ngbPopover]="deletePopoverContent"
                  [popoverTitle]="'Delete Form'"
                  #popover="ngbPopover">
                  Delete
                </button>
                <ng-template #deletePopoverContent>
                  Permanently delete this form?
                  <div class="text-end mt-2">
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm px-3 m-1"
                      (click)="popover.close()">
                      No
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm px-3 m-1"
                      (click)="popover.close(); deleteForm()">
                      Yes
                    </button>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="content-wrapper" [class.full-width]="!isSidebarOpen">
          <div class="content">
            <div #header class="sticky-header" [class.stuck]="isStuck">
              <div [ngClass]="{ 'container px-5 pt-2 pb-1': isStuck }">
                <div
                  class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
                  <input
                    [(ngModel)]="form.title"
                    (ngModelChange)="onTitleChange($event)"
                    placeholder="Title"
                    type="text"
                    class="form-control title-input fw-800" />

                  <button
                    type="button"
                    class="btn btn-primary btn-preview fw-bold"
                    (click)="previewModal.openModal()">
                    <i class="bi bi-eye me-2"></i> Preview
                  </button>
                </div>
              </div>
            </div>

            <div class="item-content">
              @if(form.sections) { @for(section of form.sections; track
              section.id; let i = $index) {
              <!-- SECTION INDICATOR -->
              <!-- <div class="section-card">
                <div class="section-header">
                  Section {{ i + 1 }} of {{ form.sections.length }}
                </div>
                <div class="section-body">
                  <div class="title">{{ section.title }}</div>
                  <p>{{ section.description }}</p>
                </div>
              </div> -->
              @if(section.questions.length === 0) {
              <div class="outer-wrapper">
                <div class="form-item-wrapper static">
                  <button
                    class="btn-reset item item-question"
                    (click)="createQuestion(section.id)">
                    <div class="item-icon">Q</div>
                    <div class="item-label">Question</div>
                  </button>
                </div>
              </div>
              } @if(section.questions && section.questions.length > 0) {
              @for(question of section.questions; track question.id) {
              <app-proforms-admin-question [question]="question" />
              } } } }
            </div>

            <div class="card outro-card mt-5" [class.focused]="isEditingOutro">
              <div
                class="card-header outro-card-header fs-6 d-flex justify-content-between">
                Outro
                <i
                  class="bi bi-info-circle-fill"
                  ngbTooltip="The outro is where you can write a confirmation message or next
          steps. Respondents will see this message once they submit the
          form."
                  containerClass="outro-card-tooltip"></i>
              </div>
              <div #outroBody>
                <ng-container *ngIf="isEditingOutro; else previewOutro">
                  <div class="card-body outro-card-body">
                    <app-wysiwyg-editor
                      [version]="'custom'"
                      [customOptions]="toolbarBottomFroalaOptions"
                      [editorContent]="form.outro"
                      (editorContentEvent)="
                        updateOutro($event)
                      "></app-wysiwyg-editor>
                  </div>
                </ng-container>
                <ng-template #previewOutro>
                  <div
                    (click)="showEditOutro($event)"
                    class="card-body outro-card-body position-relative pointer p-5">
                    <i class="bi bi-pencil color-tertiary edit-icon"></i>
                    <app-safehtml [html]="form.outro"></app-safehtml>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <app-proform-preview-modal #previewModal [formId]="formId" />
      </ng-container>
      <ng-template #loadingTemplate>
        <div
          class="w-100 position-relative"
          style="background-color: #fff; height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>
    </div>
  </div>
</div>
